import { render, staticRenderFns } from "./GatSubGroup.vue?vue&type=template&id=735389fd&scoped=true&"
import script from "./GatSubGroup.vue?vue&type=script&lang=js&"
export * from "./GatSubGroup.vue?vue&type=script&lang=js&"
import style0 from "./GatSubGroup.vue?vue&type=style&index=0&id=735389fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735389fd",
  null
  
)

export default component.exports